<template>
  <router-link
    :to="(isComingSoon || noLink) ? '' : courseUrl(course)"
    class="course-thumb-box"
    :class="{ disabled: isComingSoon, isRecentlyReleased }"
  >
    <!-- <CourseTag
      v-if="isRecentlyReleased"
      class="position--top-right"
    >
      <HotSVG />  NOVIDADE NA ÁREA!
    </CourseTag> -->

    <CourseVideoThumb20
      :thumb="course.thumb"
      :has-hover="hasHover && !isComingSoon"
      :is-coming-soon="isComingSoon"
    >
      <CourseLoadDuration
        :duration="course.load_duration"
        class="position--bottom-right"
      />
    </CourseVideoThumb20>

    <div
      v-if="!onlyThumb"
      class="content-box"
    >
      <h6 class="title">
        {{ course.name }}
      </h6>

      <slot />

      <span
        v-if="hasLiveTagSlot"
        class="highlight-tag"
      >
        <span>
          <slot name="liveTag" />
        </span>
      </span>
    </div>
  </router-link>
</template>

<script>
  import { mapGetters } from 'vuex'
  import CourseVideoThumb20 from './CourseVideoThumb20'
  import HotSVG from '@/components/svg/HotSVG'
  import CourseTag from '@/components/course/CourseTag'
  import CourseLoadDuration from '@/components/course/CourseLoadDuration'

  export default {
    components: {
      CourseVideoThumb20,
      HotSVG,
      CourseTag,
      CourseLoadDuration,
    },

    props: {
      course: { type: Object, default: () => ({}) },
      hasHover: { type: Boolean, default: true },
      isComingSoon: { type: Boolean, default: false },
      onlyThumb: { type: Boolean, default: false },
      noLink: { type: Boolean, default: false }
    },

    computed: {
      ...mapGetters('course', ['courseUrl']),

      hasLiveTagSlot () {
        return !!this.$slots.liveTag
      },

      isRecentlyReleased () {
        return this.course.is_recently_released;
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "~@/assets/sass/variables";

  .course-thumb-box {
    display: flex;
    align-items: center;
    gap: 10px;
  
    &.disabled { 
      cursor: default 
    }

    .title {
      font-family: $textSecondaryFamily;
    }

    .author {
      font-size: 1rem;
      color: $subtitlePrimaryColor;
    }

    .highlight-tag {
      display: inline-flex;
      align-items: center;
      background: #f00;
      color: #fff;
      border-radius: 5px;
      font-size: 13px;
      padding: 2px 10px;
      font-weight: 600;

      &:before {
        content: '';
        width: 6px;
        height: 6px;
        background: #fff;
        border-radius: 100%;
        margin-right: 8px;
        animation: blink 2s infinite;
        transition: .5s all;
      }
    }
  }

  @keyframes blink {
    0% { opacity: 1 }
    33% { opacity: 1 }
    66% { opacity: 0 }
    100% { opacity: 1 }
  }
</style>